<template>
  <div class="notes-section">

    <draggable class='note-spliter' group="notes" :list='notes.notes_with_recursive_children' @change='onNoteMove($event, notes)' dragClass="dragging-ticket" ghostClass="ghost-ticket" chosenClass="chosen-ticket" handle=".handle" style="padding-left: 50px;">
      <!-- include above better understanding of drop zone
        :style="{'background': dropColor}"
      -->

    <div v-for='(note, indexNote) in notes.notes_with_recursive_children' :key='note.id' class="note-li">

      <div class="drag-handle">
        <v-icon class='handle'>fas fa-grip-vertical</v-icon>
      </div>

      <div class="notes-title-arrow-btns">
        <div v-if="note.notes_with_recursive_children && note.notes_with_recursive_children.length > 0">
          <v-icon class='arrow-btn' v-show='note.active' @click="note.active = false">fas fa-chevron-down</v-icon>
          <v-icon class='arrow-btn' v-show='!note.active' @click="note.active = true">fas fa-chevron-right</v-icon>
        </div>
      </div>

      <div class="note" @click='openDrawer(note)' :class="{'focused': note.focus}">

        <div class="title" v-on:click.stop>
          <input type="text" v-model='note.title' :id="'bd' + note.id" :ref="'bd' + note.id" v-on:keyup.enter="addSameLvlNote(note, notes, indexNote)" @focus="note.focus = true" @blur="note.focus = false;updateNote(note)" role="button" aria-pressed="false" tabindex="0" placeholder="Note Title">
        </div>

         <div class="icons">

          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }" v-if='note.status'>
              <v-btn
                color="primary"
                dark
                v-bind="attrs"
                v-on="on"
              >
                <v-icon class='icon-dot'>fas fa-ellipsis-h</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item>
                <v-list-item-title>Duplicate</v-list-item-title>
              </v-list-item>
              <v-list-item @click='createSubnoteLast(note)'>
                <v-list-item-title>Sub Category</v-list-item-title>
              </v-list-item>
              <v-list-item @click='deleteNotePopupActive=true'> <!-- deleteNote(note) -->
                <v-list-item-title>Delete Note</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

        </div>

        <div class="status">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }" v-if='note.status'>
              <v-btn
                color="primary"
                dark
                v-bind="attrs"
                v-on="on"
              >
                <v-icon v-if="note.status == 'to-do'" class='icon-progress' color='#4B84FF'>fas fa-tasks</v-icon>
                <v-icon v-if="note.status == 'In-Progress'" class='icon-progress' color='#959EFF'>far fa-clock</v-icon>
                <v-icon v-if="note.status == 'Completed'" class='icon-progress' color='#4ed319'>far fa-check-circle</v-icon>

                <span v-if="note.status == 'to-do'" class="icon-text">{{note.status}}</span>
                <span v-if="note.status == 'In-Progress'" class="icon-text">{{note.status}}</span>
                <span v-if="note.status == 'Completed'" class="icon-text">{{note.status}}</span>
                <v-icon class='icon-arrow'>fas fa-caret-down</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="changeStatus(note, 'to-do')">
                <v-list-item-title>To-Do</v-list-item-title>
              </v-list-item>
              <v-list-item @click="changeStatus(note, 'In-Progress')">
                <v-list-item-title>In-Progress</v-list-item-title>
              </v-list-item>
              <v-list-item @click="changeStatus(note, 'Completed')">
                <v-list-item-title>Completed</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>

      </div>

      <!-- Child Notes -->
      <div v-show='note.active'>
        <note ref="childTest" :notes="note" :moduleId="notes.id" :key="componentKey"></note>
      </div>
      <!-- Child notes end -->

      <div class="deleteNotePopupWrap" v-if='deleteNotePopupActive'>
        <div class="deleteNotePopup">
          <div>
            Are you sure you want to delete this Note? <br/>
            <span style="font-size: 14px;color: #e76f51;">(All sub-notes will be deleted)</span>
          </div>
          <div class="delete-btns">
            <div class="delete" @click="deleteNote(note, indexNote);deleteNotePopupActive=false">
              Delete
            </div>
            <div class="cancel" @click="deleteNotePopupActive=false">
              Cancel
            </div>
          </div>
        </div>
      </div>

    </div>

    </draggable>


  </div>
</template>

<script>
import Vue from 'vue'
import api from '@/api'
import draggable from 'vuedraggable'
import SlVueTree from 'sl-vue-tree'
import Subnote from '@/components/dashboard/Subnote'

export default {
  name: 'Note',
  props: ['notes'],
  components: {
    draggable,
    Subnote,
    SlVueTree
  },

  data () {
  	return {
  	 componentKey: 0,
     colors: [],
     dropColor: null,
     deleteNotePopupActive: false
  	}
  },

  computed: {

  },

  methods: {

    async createSubnoteLast (parent) {
    // createSubnoteLast - adds subnote at the end of a selected note list
      let note = {
        title: '',
        status: 'to-do',
        description: '',
        check: false,
        focus: false,
        list: false,
        active: 1,
        parent_id: parent.id,
        module_id: parent.module_id,
      }

      // store new note
      const response = await api.notes.store(note)
      if (response.status < 300) {
        let newNote = response.data.note
        // check and adds array is does not exist
        if (!response.data.note.notes_with_recursive_children) {
          newNote.notes_with_recursive_children = []
        }
        parent.notes_with_recursive_children.push(newNote) // add element in DOM
        var customId = 'bd' + response.data.note.id
        this.focusInput(customId) // focus on newly added element
        this.$store.commit('incrementState') // force rerender
        console.log('parent.notes_with_recursive_children!!', parent)
        console.log('parent.notes_with_recursive_children', parent.notes_with_recursive_children)
      } else {
        // handle errors
        console.log('Response error', response)
      }
    },

    generateColors () {
      while (this.colors.length < 100) {
        do {
          var color = Math.floor((Math.random()*1000000)+1)
        } while (this.colors.indexOf(color) >= 0)
        this.colors.push("#" + ("000000" + color.toString(16)).slice(-6))
      }
    },

    async onNoteMove (evt, parent) {

      // added element
      if (evt.added) {

          let data = {
            element: evt.added.element,
            parent: parent
          }
          // TODO upgrage later, new index, old index
          const response = await api.notes.onNoteMoveList(data)
          if (response.status < 300) {
            console.log('ELEMENT ADDED',)
            console.log('ADDED PARENT', parent)
            console.log('ADDED RESPONSE', response.data)
          }
      }

      // removed element
      if (evt.removed) {
        console.log('ELEMENT REMOVED')
      }

      // moved element inside parent (for resort)
      if (evt.moved) {
          // TODO upgrade later, new index, old index
          const response = await api.notes.onNoteMove(parent)
          if (response.status < 300) {
            // console.log('MOVED RESPONSE', response.data)
          } else {
            console.log('error')
          }
      }

    },

    async addSameLvlNote (element, parent, index=null) {
      let parentId, moduleId
      console.log('parent', parent)
      // check if note is at top lvl
      if (parent.hasOwnProperty('education_title')) {
        parentId = null
        moduleId = parent.id
      } else {
        parentId = element.parent_id
        moduleId = element.module_id
      }

      // define note
      let note = {
        title: '',
        status: 'to-do',
        description: '',
        check: false,
        focus: false,
        list: false,
        active: 1,
        parent_id: parentId,
        module_id: moduleId
      }

      console.log('note', note)

      // store new note
      const response = await api.notes.store(note)
      if (response.status < 300) {
        var newNote = response.data.note
        // check and adds array is does not exist
        if (!response.data.note.notes_with_recursive_children) {
          newNote.notes_with_recursive_children = []
        }
        parent.notes_with_recursive_children.splice(index + 1, 0, newNote) // add element in DOM

        var customId = 'bd' + response.data.note.id // find ref of element
        var self = this

        // reorder
        const responseIn = await api.notes.reorder(parent)
        if (responseIn.status < 300) {
          // focus input on next DOM rerender
          self.focusInput(customId)
        }
        // this.$store.commit('incrementState') // force rerender

      } else {
        // handle errors
        console.log('Response error', response)
      }
    },

    focusInput(elementId) {
      /*
      console.log('refffff', ref)
      console.log('refffffsssss', this.$refs)
      var self = this
      Vue.nextTick()
        .then(function () {
          self.$refs[ref][0].focus()
      })
      */
      Vue.nextTick()
        .then(function () {
          document.getElementById(elementId).focus()
      })
    },

    async deleteNote (note) {
      const response = await api.notes.deleteNote(note.id)
      if (response.status < 300) {
        console.log('response', response.data)
        // remove element from vue data
        for( var i = 0; i < this.notes.notes_with_recursive_children.length; i++){
            if ( this.notes.notes_with_recursive_children[i].id === note.id) {
                this.notes.notes_with_recursive_children.splice(i, 1);
            }
        }

        this.$store.commit('incrementState')
      }
    },

    openDrawer (note) {
      this.$store.commit('openNoteDrawer') // open drawer
      this.$store.commit('setCurrentNote', note) // store selected note
    },


    // OLD

    // save note
    async storeNote (note, parentNote, item, type, index=null) {
      // store new note
      const response = await api.notes.store(note)
      if (response.status < 300) {
        if (type == 'last') {
          item.notes_with_recursive_children.push(response.data.note) // add element
          let ref = 'bd' + response.data.note.id // find ref of element
          this.focusInput(ref) // focus on next element
        } else {
          item.notes_with_recursive_children.splice(index + 1, 0, response.data.note) // add element
          let ref = 'bd' + response.data.note.id // find ref of element
          this.focusInput(ref) // focus on next element
        }
        console.log('Note created!', response.data)
      } else {
        console.log('Response error', response)
      }
    },

    async updateNote (note) {
      const response = await api.notes.update(note, note.id)
      if (response.status < 300) {
        console.log('Note updated!', response.data)
      } else {
        console.log('Response error', response)
      }
    },


    addNote (parentNote, item, index=null) {

      let note = {
        title: '',
        status: 'to-do',
        description: '',
        check: false,
        focus: false,
        list: false,
        parent_id: parentNote.id,
        module_id: item.id,
      }

      if(index == null) {
        // action for +addnote btn
        this.storeNote(note, parentNote, item, 'last',) // add new element to DB
      } else {
        this.storeNote(note, parentNote, item, 'mid', index) // add new element to DB
      }
    },

    addSubnote (parentNote, item, index=null) {
      let note = {
        title: '',
        status: 'to-do',
        description: '',
        check: false,
        focus: false,
        list: false,
        parent_id: parentNote.id,
        module_id: item.id,
      }

      this.storeSubNote(note, parentNote, item, index)
    },

    // save note
    async storeSubNote (note, parentNote, item, index=null) {
      // store new note
      const response = await api.notes.store(note)
      if (response.status < 300) {

        if (!parentNote.child_notes_recursive) {
          parentNote.child_notes_recursive = []
        }

          parentNote.child_notes_recursive.push(response.data.note) // add element
          let ref = 'bd' + response.data.note.id // find ref of element
          this.focusInput(ref) // focus on next element
          this.$store.commit('incrementState')
      } else {
        console.log('Response sub error', response)
      }
    },

    changeStatus (note, status) {
      // TODO
      note.status = status
      this.updateNote(note, status)
    },

    customRender() {
      this.componentKey += 1;
    },

    async updateNoteOrder (evt, moduleId) {

      var element = null
      var newModuleId = 0

      // added element
      if (evt.added) {
          element = evt.added.element
          newModuleId = moduleId

          let data = {
            module: this.notes.notes_with_recursive_children,
            element: element,
            moduleId: newModuleId
          }

          json_

          // TODO upgrage later, new index, old index
          const response = await api.notes.updateOrder(JSON.stringify(data))
          if (response.status < 300) {
            console.log('response update order', response.data)
          }
      }

      // removed element
      if (evt.removed) {
          element = evt.removed.element
      }

      // moved element
      if (evt.moved) {
          element = evt.moved.element

          let data = {
            module: this.notes.notes_with_recursive_children,
            element: null,
            moduleId: null
          }

          // TODO upgrage later, new index, old index
          const response = await api.notes.updateOrder(data)
          if (response.status < 300) {
            console.log('response update order', response.data)
          }
      }

    },



  },

  created () {

  },

  mounted () {
    this.generateColors()
    this.dropColor = this.colors[Math.floor(Math.random() * 101)]
  }
}
</script>


<style lang="scss" scoped="scoped">

  .note:focus-within {
    background: #EFF1F6 !important;
  }

  .title:focus-within {
      background: #fff !important;
  }

  .dragging-ticket {
    opacity: 0 !important;
    .note {

    }

    .handle {

    }
  }

  .ghost-ticket {
    width: 100% !important;
    height: 5px !important;
    background: #dadada !important;
    overflow: hidden !important;

    .handle {

    }
  }

  .chosen-ticket {
    .note {
      height: 0 !important;
      opacity: 0;
    }

    .notes-title-arrow-btns {
      display: none;
    }

    .handle {
      opacity: 0;
    }
  }

  .handle {
    float: left;
    padding-top: 8px;
    padding-bottom: 8px;
  }


  .notes-section {

    .note-spliter {

      &:hover {

        .drag-handle {
          display: block;
        }
      }
    }

    .note-li {

      /*
      &:hover {

        .drag-handle {
          display: block;
        }
      }
      */

      .drag-handle {
        position: absolute;
        width: 20px;
        margin-top: 14px;
        margin-left: -45px;
        cursor: pointer;
        transition: all 0.5s;
        display: none;


        &:hover {
          opacity: 0.65;
        }

        .handle {
          font-size: 14px;
          color: #a0aabd;
        }
      }
    }


    .notes-title-arrow-btns {
      position: absolute;
      width: 20px;
      margin-left: -21px;
      line-height: 60px;

      button:before {
        font-size: 14px;
        color: #A0AABD;
      }
    }

    .note {
      width: 100%;
      height: 60px;
      margin-left: 0;
      margin-top: 15px;
      margin-bottom: 15px;
      line-height: 60px;
      border-left: 5px solid #4c84ff;
      border-radius: 5px;
      background: #fff;
      transition: all 0.25s;
      cursor: pointer;

      &:hover {
        background: #EFF1F6;

        .title {
          background: #fff;
        }
      }

      .checkbox {
        float: left;

        .custom-checkbox {
          padding-left: 20px;
        }
      }


      .title {
        float: left;
        min-width: 30px;
        width: 25%;
        height: 40px;
        margin-top: 10px;
        margin-left: 15px;
        padding-left: 15px;
        font-size: 16px !important;
        font-weight: 400;
        border-radius: 5px;
        line-height: 42px;
        color: #3A414F;

        input {
          width: 100%;
          outline: none;
          color: #3A414F;
        }
        input::placeholder {
          color: #dedfe0;
        }
      }

      .needs {
        float: left;
        margin-left: 10%;
        width: 15%;
        padding-left: 5px;
        font-size: 12px !important;
        font-weight: 400;
        line-height: 64px;
        color: #8790a1;
      }

      .status {
        float: right;

        .icon-dot {

        }

        .icon-progress {
          font-size: 16px;
        }

        .icon-text {
          padding-top: 2px;
          padding-left: 5px;
          font-family: 'Roboto', sans-serif;
          font-size: 12px !important;
          font-weight: 400;
          text-transform: capitalize;
          letter-spacing: 0;
          color: #9fa9bc;
        }

        .icon-arrow {
          font-size: 16px;
          padding-left: 5px;
          color: #9fa9bc;
        }
      }

      .icons {
        float: right;
        padding-right: 20px;

        .icon-dot {
          font-size: 14px;
          color: #9fa9bc;
          cursor: pointer;
          transition: all 0.25s;

          &:hover {
            opacity: 0.7;
          }
        }

        .icon-full {
          font-size: 20px;
          color: #9fa9bc;
          cursor: pointer;
          transition: all 0.25s;

          &:hover {
            opacity: 0.7;
          }
        }
      }
    }

    .add-note {
      margin-top: 10px;
      padding-left: 15px;
      font-size: 14px;
      font-weight: 300;
      color: #9fa9bc;
      cursor: pointer;
      transition: all 0.25s;

      &:hover {
        opacity: 0.7;
      }
    }

    .add-subnote {
      margin-top: -10px;
      margin-bottom: 10px;
      padding-left: 30px;
      font-size: 12px;
      font-weight: 300;
      color: #9fa9bc;
      cursor: pointer;
      transition: all 0.25s;

      &:hover {
        opacity: 0.7;
      }
    }
  }

  .deleteNotePopupWrap {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background: rgba(0,0,0,0.05);
    z-index: 999;

    .deleteNotePopup {
      width: 500px;
      margin-top: 20%;
      margin-left: calc(50% - 250px);
      padding: 20px;
      border-radius: 3px;
      background: #fff;

      .delete-btns {
        text-align: right;
        overflow: auto;

        .delete {
          float: right;
          width: 100px;
          height: 40px;
          margin-left: 15px;
          line-height: 40px;
          text-align: center;
          border-radius: 3px;
          background: #e76f51;
          color: #fff;
          cursor: pointer;
          transition: all 0.5s;

          &:hover {
            opacity: 0.6;
          }
        }

        .cancel {
          float: right;
          width: 100px;
          height: 40px;
          margin-left: 15px;
          line-height: 40px;
          text-align: center;
          border-radius: 3px;
          background: #d7dbde;
          color: #fff;
          cursor: pointer;
          transition: all 0.5s;

          &:hover {
            opacity: 0.6;
          }
        }
      }
    }
  }

</style>
